import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));
